import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AnswerModel } from 'Pages/survey'
import { Callback } from 'Src/types/utilTypes'

export namespace AnswerNS {
	export type CreateOne = PayloadAction<{
		attempt_id: number
		question_id: number
		data: AnswerModel
		callback?: Callback
		errorCallback?: Callback
	}>
	export type UpdateOne = PayloadAction<{
		answer_id: number
		data: AnswerModel
		callback?: Callback
		errorCallback?: Callback
	}>
	export type DeleteOne = PayloadAction<{
		id: number
		callback?: Callback
	}>
}

export const answerSlice = createSlice({
	name: 'answer',
	initialState: {},
	reducers: {
		createOne: (state, action: AnswerNS.CreateOne) => {},
		updateOne: (state, action: AnswerNS.UpdateOne) => {},
		deleteOne: (state, action: AnswerNS.DeleteOne) => {},
	},
})
